import React, { useState, useEffect, Fragment, useRef } from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import clsx from "clsx";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Container from "@material-ui/core/Container";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import AnchorLink from "react-anchor-link-smooth-scroll";
import {
  ArrowDownward,
  ArrowDropDown,
  ArrowForwardIos,
  ExpandMore,
  KeyboardArrowDown,
  Menu as MenuIcon,
  Person,
} from "@material-ui/icons";
import { MenuItem, FormControl, Select } from "@material-ui/core";
import Scrollspy from "react-scrollspy";
import MobileMenu from "./MobileMenu";
import mfsLogo from "../../static/images/mfs/header-logo.png";
import { withTranslation } from "~/i18n";
import linkRouter from "~/static/text/link";
import "~/vendors/hamburger-menu.css";
import useStyles from "./header-style";
import navMenu from "./menu";
import { getUserData } from "../../helpers/authentication";
import { showLogoutModal } from "../../helpers/general";
import { destroyUserCookie } from "../../helpers/cookie";
import { getCountryPaymentDetail } from "../../static/static-data/payment/static_payment_data";
import { getPaymentCountry } from "../../helpers/setCookie";
import {
  closeChooseCountryModal,
  openChooseCountryModal,
} from "../../reducers/general/actions";

const accountLogin = require("../../static/images/mobile_account_login.png");

const popoverStyle = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  getContentAnchorEl: null,
  style: {
    marginTop: 6,
    marginLeft: -10,
    zIndex: 999999999,
  },
};

let counter = 0;
function createData(name, url, offset) {
  counter += 1;
  return {
    id: counter,
    name,
    url,
    offset,
  };
}

const LinkBtn = React.forwardRef(
  (props, ref) => (
    // eslint-disable-line
    <AnchorLink to={props.to} {...props} innerRef={ref} />
  ), // eslint-disable-line
);

function Header(props) {
  const [selectedPaymentCountry, setSelectedPaymentCountry] = React.useState(
    null,
  );
  const [fixed, setFixed] = useState(false);
  const [userData, setUserData] = useState(null);
  const [accountPopup, setAccountPopup] = useState(false);
  const selectAccountRef = useRef({});
  let flagFixed = false;
  const handleScroll = () => {
    const doc = document.documentElement;
    const scroll = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    const newFlagFixed = scroll > 100;
    if (flagFixed !== newFlagFixed) {
      setFixed(newFlagFixed);
      flagFixed = newFlagFixed;
    }
  };

  const handleGetData = async () => {
    if (!props.disableDestroyUser) {
      try {
        const dataUser = getUserData();
        // Always set userData when localStorage has a profile so the topbar
        // shows the logged-in user (name + avatar fallback) on /flashdeals
        // and elsewhere. Newly-registered accounts may not have avatar_thumbnails
        // populated yet; previously that would silently keep userData=null and
        // render the Login/Register button despite an active session.
        if (dataUser) {
          setUserData(dataUser);
        }
      } catch (err) {
        // console.log('FAILED GET DATA PROFILE :', err);
      }
    }
  };

  useEffect(() => {
    console.log("[HEADER] SOURCES:", props.headerSource);
    window.addEventListener("scroll", handleScroll);
    handleGetData();
    const countrySelected = getPaymentCountry();
    const countryItem = getCountryPaymentDetail(countrySelected);
    setSelectedPaymentCountry(countryItem);
  }, []);
  const classes = useStyles();
  const theme = useTheme();
  const { invert, isTrans, containerRootStyle, t, i18n, appBarStyle } = props;
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const selectRef = useRef({});

  const [openDrawer, setOpenDrawer] = useState(false);
  const [articlePopup, setArticlePopup] = useState(false);

  const [menuList] = useState([
    createData(navMenu[0], linkRouter.mobile.downloadAppRoot),
    createData(navMenu[1], linkRouter.mobile.downloadAppRoot),
    createData(navMenu[2], linkRouter.mobile.articles),
    createData(navMenu[3], linkRouter.mobile.tools),
    createData(navMenu[4], linkRouter.mobile.loginMenu),
  ]);

  const [articleDropdown] = useState([
    {
      id: "fatloss",
      link: linkRouter.mobile.articleCategory("fatloss"),
      label: "fatlossDefault",
    },
    {
      id: "workout",
      link: linkRouter.mobile.articleCategory("workouts"),
      label: "workoutDefault",
    },
    {
      id: "nutrition",
      link: linkRouter.mobile.articleCategory("nutrition"),
      label: "nutritionDefault",
    },
    {
      id: "healthy-living",
      link: linkRouter.mobile.articleCategory("healthy-living"),
      label: "healthy_livingDefault",
    },
    {
      id: "personal-development",
      link: linkRouter.mobile.articleCategory("personal-development"),
      label: "personal_developmentDefault",
    },
  ]);

  const handleShowModalCountry = () => {
    const handleSave = (countryId) => {
      setSelectedPaymentCountry(getCountryPaymentDetail(countryId));
      closeChooseCountryModal();
      window.location.reload();
    };
    openChooseCountryModal(handleSave);
  };

  const handleOpenDrawer = () => {
    setOpenDrawer(!openDrawer);
  };

  const showAccountPopup = () => {
    if (!accountPopup) {
      setAccountPopup(true);
    }
  };

  const handleSelectAccount = (event) => {
    if (event.target.value === "logout") {
      showLogoutModal("normal-user");
    }
    setAccountPopup(false);
  };

  const hideAccountPopup = () => {
    setAccountPopup(false);
  };

  const showPopupArticle = () => {
    if (!articlePopup) {
      setArticlePopup(true);
    }
  };

  const hidePopupArticle = () => {
    setArticlePopup(false);
  };

  function renderAccountView() {
    return (
      <div className={classes.ctnAccount}>
        <Button
          onMouseEnter={isMobile ? null : showAccountPopup}
          onClick={isMobile ? showAccountPopup : null}
          offset={0}
          href="#"
          className={clsx(
            classes.accountWrapper,
            isTrans && !fixed ? classes.isTrans : "",
          )}
        >
          {userData.avatar_thumbnails && userData.avatar_thumbnails.a ? (
            <img
              src={userData.avatar_thumbnails.a}
              alt="avatar"
              className={classes.avatarStyle}
            />
          ) : (
            // Fallback when freshly-registered users have no avatar yet —
            // keep an icon so the topbar still indicates an active session.
            <Person className={classes.icnUser} />
          )}
          {isDesktop ? (userData.first_name || userData.full_name || userData.email) : null}
        </Button>
        <FormControl className={classes.formRoot}>
          <Select
            id="selectAccount"
            name="account"
            className={clsx(classes.selectedStyle)}
            open={accountPopup}
            ref={selectAccountRef}
            value=""
            onChange={handleSelectAccount}
            disableUnderline
            MenuProps={{
              ...popoverStyle,
              style: {
                ...popoverStyle,
                marginTop: 12,
                zIndex: 999999999,
              },
              onMouseLeave: hideAccountPopup,
              onClick: hideAccountPopup,
            }}
          >
            <a
              href={linkRouter.mobile.accountOverview}
              className={clsx(classes.linkStyle, classes.rowLink)}
            >
              <MenuItem value="overview">Account Overview</MenuItem>
            </a>
            <MenuItem key="logout" value="logout">
              Logout
            </MenuItem>
          </Select>
        </FormControl>
      </div>
    );
  }

  function renderButtonLogin(item) {
    return (
      <Button
        offset={item.offset || 0}
        href={item.url}
        className={clsx(
          classes.registButton,
          isTrans && !fixed ? classes.isTrans : "",
        )}
      >
        <Person className={classes.icnUser} />
        {t("mobile-landing:header_login_register")}
      </Button>
    );
  }

  function renderLoginMobile() {
    if (userData) {
      return renderAccountView();
    }
    return (
      <div className={classes.ctnAccount}>
        <Button
          offset={1}
          href={menuList[4].url}
          className={clsx(
            classes.accountWrapper,
            isTrans && !fixed ? classes.isTrans : "",
          )}
        >
          <img
            src={accountLogin}
            alt="avatar"
            className={classes.avatarStyle}
          />
        </Button>
      </div>
    );
  }

  function renderMenu(item) {
    // Use name match instead of id===5: createData increments a module-level
    // counter, so id can drift past 5 when the Header remounts.
    if (item.name === "login_register") {
      if (isMobile) {
        return (
          <div className={classes.ctnAccount}>
            <Button
              offset={1}
              href={item.url}
              className={clsx(
                classes.accountWrapper,
                isTrans && !fixed ? classes.isTrans : "",
              )}
            >
              <img
                src={accountLogin}
                alt="avatar"
                className={classes.avatarStyle}
              />
            </Button>
          </div>
        );
      }
      if (userData) {
        return renderAccountView();
      }
      return renderButtonLogin(item);
    }
    if (item.name === "articles") {
      return (
        <Fragment>
          <Button
            onMouseEnter={() => {
              showPopupArticle();
            }}
            offset={item.offset || 0}
            href={item.url}
            className={isTrans && !fixed ? classes.isTrans : ""}
          >
            {t("mobile-landing:header_" + item.name)}
          </Button>
          <FormControl className={classes.formRoot}>
            <Select
              id="demo-simple-select"
              className={clsx(classes.selectedStyle)}
              open={articlePopup}
              ref={selectRef}
              value=""
              disableUnderline
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
                style: {
                  marginTop: 6,
                  marginLeft: -10,
                  zIndex: 999999999,
                },
                onMouseLeave: () => hidePopupArticle(),
                // onMouseLeave: () => console.log('Catch mouse leave'),
                onClick: () => hidePopupArticle(),
              }}
            >
              {articleDropdown.map((c) => (
                <a href={c.link} key={c.id} className={classes.linkStyle}>
                  <MenuItem value={c.id}>
                    {t("myfitsociety:" + c.label)}
                  </MenuItem>
                </a>
              ))}
            </Select>
          </FormControl>
        </Fragment>
      );
    }
    return (
      <Button
        offset={item.offset || 0}
        href={item.url}
        className={isTrans && !fixed ? classes.isTrans : ""}
      >
        {t("mobile-landing:header_" + item.name)}
      </Button>
    );
  }

  // function renderCountryPayment() {
  //   if (isMobile || !!selectedPaymentCountry === false) {
  //     return null;
  //   }
  //   return (
  //     <div
  //       className={classes.ctnCountryPayment}
  //       onClick={handleShowModalCountry}
  //       onKeyDown={handleShowModalCountry}
  //       role="button"
  //       tabIndex={0}
  //     >
  //       <img src={selectedPaymentCountry.source} alt="flag" />
  //       <span>
  //         {selectedPaymentCountry.key === "SG"
  //           ? t("myfitsociety:singapore")
  //           : selectedPaymentCountry.title}
  //       </span>
  //       <KeyboardArrowDown className={classes.arrowIcon} />
  //     </div>
  //   );
  // }

  return (
    <Fragment>
      {isMobile && (
        <MobileMenu
          userData={userData}
          open={openDrawer}
          toggleDrawer={handleOpenDrawer}
        />
      )}
      <AppBar
        component="header"
        position="relative"
        id="header"
        className={clsx(
          classes.header,
          fixed && classes.fixed,
          openDrawer && classes.openDrawer,
          appBarStyle,
        )}
      >
        <Container
          fixed={isDesktop}
          className={clsx(classes.containerRootStyle, containerRootStyle)}
        >
          <div className={classes.headerContent}>
            <nav className={clsx(classes.navMenu, invert && classes.invert)}>
              {isMobile && (
                <div className={classes.mobileMenu}>
                  <IconButton
                    onClick={handleOpenDrawer}
                    className={clsx(
                      "hamburger hamburger--spin",
                      openDrawer && "is-active",
                    )}
                  >
                    <span className="hamburger-box">
                      <MenuIcon className={classes.icnStyle} />
                    </span>
                  </IconButton>
                  {renderLoginMobile()}
                </div>
              )}
              <div className={`${classes.logo} ${classes.logoAdjust}`}>
                {invert ? (
                  <a href="/">
                    <img src={mfsLogo} alt="logo" />
                    {/* {!isMobile && brand.mobile.projectName} */}
                  </a>
                ) : (
                  <a href="/">
                    <img src={mfsLogo} alt="logo" />
                    {/* {!isMobile && brand.mobile.projectName} */}
                  </a>
                )}
              </div>
              {isDesktop && (
                <Scrollspy items={navMenu} currentClassName="active">
                  {menuList.map((item) => (
                    <li key={item.id.toString()}>{renderMenu(item)}</li>
                  ))}
                </Scrollspy>
              )}
            </nav>
            {/* {renderCountryPayment()} */}
          </div>
        </Container>
      </AppBar>
    </Fragment>
  );
}

Header.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  onToggleDark: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  onToggleDir: PropTypes.func,
  invert: PropTypes.bool,
  t: PropTypes.func.isRequired,
  isTrans: PropTypes.bool,
  containerRootStyle: PropTypes.string,
  i18n: PropTypes.object.isRequired,
  showFlag: PropTypes.bool,
  appBarStyle: PropTypes.object,
};

Header.defaultProps = {
  sticky: false,
  invert: false,
  onToggleDark: () => {},
  onToggleDir: () => {},
  isTrans: false,
  containerRootStyle: "",
  showFlag: false,
  appBarStyle: {},
};

export default withTranslation(["mobile-landing", "myfitsociety"])(Header);
